import React, { useState } from 'react';
import { Label } from '../Label';
import { BaseTextInput, BaseTextArea, FormTextElementWrapper, } from './BaseFormText';
import { FormTextProvider } from './context';
import { useFormText } from './useFormText';
import { filterFormTextProps } from './utils';
import { addAllyTM } from '../tools/utils';
const FormText = React.forwardRef((props, ref) => {
    const { value, withAllyTM = true } = props;
    const internalRef = React.useRef(null);
    const combinedRef = (node) => {
        if (typeof ref === 'function') {
            ref(node);
        }
        if (ref && typeof ref === 'object') {
            ref.current = node;
        }
        internalRef.current = node;
    };
    const [isFocused, setFocused] = useState(false);
    const [isHovered, setHovered] = useState(false);
    const { variant, labelContent, className, formTextId, describedBy, hasError, isDisabled, formFieldHelper, inlineContextualHelp, characterCounter, characterCounterWidth, } = useFormText(Object.assign(Object.assign({}, props), { internalRef, isFocused, isHovered }));
    const { inputWidth } = props;
    const allyTM = addAllyTM({
        content: value,
        id: formTextId,
        elementType: 'form',
        withAllyTM,
    });
    return (React.createElement(FormTextProvider, { className: className, hasError: hasError, isDisabled: isDisabled, isFocused: isFocused, isHovered: isHovered, setFocused: setFocused, setHovered: setHovered },
        React.createElement(Label, { htmlFor: formTextId }, labelContent),
        React.createElement(FormTextElementWrapper, { formTextElement: variant === 'input' ? (React.createElement(BaseTextInput, Object.assign({}, filterFormTextProps(props), { id: formTextId, "aria-describedby": describedBy, characterCounterWidth: characterCounterWidth, ref: combinedRef }, allyTM))) : (React.createElement(BaseTextArea, Object.assign({}, filterFormTextProps(props), { id: formTextId, "aria-describedby": describedBy, ref: combinedRef }, allyTM))), formFieldHelper: formFieldHelper, inlineContextualHelp: inlineContextualHelp, characterCounter: characterCounter, inputWidth: inputWidth })));
});
export { FormText };
//# sourceMappingURL=FormText.js.map